import {DocumentNode, gql} from "@apollo/client";

export const PAYMENT_QUERY: DocumentNode = gql(`    
    query GetPayment($id: Float!) {
        getPaymentOperation(operationId: $id) {
            ...PaymentPanelInfo
        }
    }
`);
